import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=40c929b2&lang=less"
import "./index.vue?vue&type=style&index=1&id=40c929b2&lang=less"

const __exports__ = script;

export default __exports__